import AppIcon from '@/components/AppIcon.vue';
import AppPopover from "@/components/AppPopover.vue";
import Icons from "@/components/icons";
export default {
  name: "PpcBisSettingsHistoryPopover",
  emits: ["close", "shown", "hidden"],
  components: {
    ...Icons,
    AppIcon,
    AppPopover
  },
  props: {
    historical_settings: {
      type: Array,
      default: () => []
    },
    target: {
      type: String
    }
  },
  methods: {
    formatBiddingType(value) {
      return value === 'ltv' ? 'First + repeat purchases' : 'First purchase only';
    },
    formatDate(input) {
      const suffixes = ['th', 'st', 'nd', 'rd'];
      const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
      const date = new Date(input.replace(' ', 'T'));
      const day = date.getDate();
      const daySuffix = (d => {
        if (d > 3 && d < 21) return 'th';
        return suffixes[d % 10] || 'th';
      })(day);
      const month = months[date.getMonth()];
      const year = `'${date.getFullYear().toString().slice(-2)}`;
      const hours = String(date.getHours()).padStart(2, '0');
      const minutes = String(date.getMinutes()).padStart(2, '0');
      return `${day}${daySuffix} ${month} ${year}, ${hours}:${minutes}`;
    }
  }
};